import React from 'react';
import s from './s.module.less';
import { getAvailableHoursInNextNHours } from 'api/provider';
import { getHasCloseSetMoreTimeBanner, setHasCloseSetMoreTimeBanner } from 'utils/localstore';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'constants/path';

//https://www.figma.com/design/rWhgWwp3dNeYzTPJMPoqVP/Marketing?node-id=5665-19681&p=f&t=OzEuZBDV361dTWKN-0
const SetMoreTimeBanner = () => {
    const [showBanner, setShowBanner] = React.useState(false);
    const navigate = useNavigate();

    React.useEffect(() => {
        const fetchAvailableHours = async () => {
            const result = await getAvailableHoursInNextNHours(48);
            if (!result.error) {
                const availableHours = result.data.data || 0;
                setShowBanner(availableHours < 2);
            }
        };
        const hasCloseSetMoreTimeBanner = getHasCloseSetMoreTimeBanner();
        if (hasCloseSetMoreTimeBanner) {
            return;
        }
        fetchAvailableHours();
    }, []);

    if (!showBanner) {
        return null;
    }
    return (
        <div className={s.wrap}>
            <div className={s.icon}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM11 6C11 6.55228 10.5523 7 10 7C9.44772 7 9 6.55228 9 6C9 5.44772 9.44772 5 10 5C10.5523 5 11 5.44772 11 6ZM9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11V14C9 14.5523 9.44772 15 10 15H11C11.5523 15 12 14.5523 12 14C12 13.4477 11.5523 13 11 13V10C11 9.44772 10.5523 9 10 9H9Z" fill="#FBBF24" />
                </svg>
            </div>
            <div className={s.info}>
                <div className={s.title}>
                    Patients are finding you on Pro-Listings — open more time to capture them!
                </div>
                <div className={s.des}>
                    Your visibility is high, but availability in the next 48 hours is too limited. Check if next-day blocks or long minimum notice settings are preventing bookings.
                </div>
                <div
                    onClick={() => {
                        navigate(`${PATH.DASHBOARD}/${PATH.CALENDAR_SETTING}`);
                    }}
                    className={s.btn}
                >
                    Add more availability
                </div>
            </div>
            <div
                onClick={() => {
                    setShowBanner(false);
                    setHasCloseSetMoreTimeBanner(true);
                }}
                className={s.icon}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L10 8.58579L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L11.4142 10L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L10 11.4142L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L8.58579 10L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z" fill="#B45309" />
                </svg>
            </div>
        </div>
    );
};

export default SetMoreTimeBanner;
